import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, type Role } from '../auth';

interface Props {
  allow: Role[];
  fallback?: string;
}

/**
 * Permite acceso a la ruta solo si el usuario tiene alguno de los roles `allow`.
 * Si no, redirige a `fallback` (default `/`).
 */
export function RoleRoute({ allow, fallback = '/' }: Props) {
  const { user } = useAuth();
  const allowed = !!user && allow.some(role => user.groups.includes(role));
  if (!allowed) return <Navigate to={fallback} replace />;
  return <Outlet />;
}
